<template>
  <div>
  <!-- since the request was successful, show the results -->
    <v-row>
      <v-col cols="12" md="3" lg="2">
        <profile-card
          :username="username"
          :platform="platform"
          :accountId="accountId"
          :user-data="userData"
        />
      </v-col>
      <v-col cols="12" md="9" lg="10">
        <v-tabs
          background-color="transparent"
          v-model="tabNavigation"
          icons-and-text
          color="primary"
          show-arrows
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-overview">
            Overview
            <v-icon>data_saver_off</v-icon>
          </v-tab>

          <v-tab href="#tab-engagement">
            Engagement
            <v-icon>bar_chart</v-icon>
          </v-tab>

          <v-tab href="#tab-audience">
            Audience
            <v-icon>groups</v-icon>
          </v-tab>

          <v-tab href="#tab-posts">
            Posts
            <v-icon>image</v-icon>
          </v-tab>

          <v-tab
            v-if="shouldShowReelsTab"
            href="#tab-reels"
          >
            Reels
            <v-icon>movie</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabNavigation">
          <v-tab-item value="tab-overview">
            <v-card flat color="accent">
              <v-card-text class="black--text">
                <overview
                  :platform="platform"
                  :user-data="userData"
                  :overview-data="overviewData"
                  :audience-data="audienceData"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-engagement">
            <v-card flat color="accent">
              <v-card-text class="black--text">
                <engagement
                  :platform="platform"
                  :user-data="userData"
                  :engagement-data="engagementData"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-audience">
            <v-card flat color="accent">
              <v-card-text class="black--text">
                <audience
                  :platform="platform"
                  :user-data="userData"
                  :audience-data="audienceData"
                  :total-values="totalValues"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-posts">
            <v-card flat color="accent">
              <v-card-text class="black--text">
                <posts
                  :platform="platform"
                  :user-data="userData"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item
            v-if="shouldShowReelsTab"
            value="tab-reels"
          >
            <v-card flat color="accent">
              <v-card-text class="black--text">
                <reels
                  :platform="platform"
                  :user-data="userData"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// Import children components
const Posts = () => import("@/blocks/user-profile/Posts.vue")
const Reels = () => import("@/blocks/user-profile/Reels.vue")
const Overview = () => import("@/blocks/user-profile/Overview.vue")
const Audience = () => import("@/blocks/user-profile/Audience.vue")
const Engagement = () => import("@/blocks/user-profile/Engagement.vue")
const ProfileCard = () => import("@/blocks/user-profile/ProfileCard.vue")

// Export the SFC
export default {
  // Name of the component
  name: "AppView",

  // Accept incoming data from parent
  props: {
    username: {
      type: String,
      required: true,
    },

    platform: {
      type: String,
      required: true,
    },

    accountId: {
      type: [String, Number],
      required: false,
      default: null
    },

    userData: {
      type: Object,
      required: true,
    },

    overviewData: {
      type: Object,
      required: true
    },

    engagementData: {
      type: Object,
      required: true
    },

    audienceData: {
      type: Object,
      required: true
    },

    totalValues: {
      type: Object,
      required: true
    }
  },

  // Register components
  components: {
    // Shown in the first grid section
    ProfileCard,

    // Shown in second grid section, as tab elements
    Overview,
    Engagement,
    Audience,
    Posts,
    Reels
  },

  // Local data variables
  data: () => ({
    // For the tabs menu between overview, engagements, audience, posts and reels
    tabNavigation: null,
  }),

  // Computable readonly data variables
  computed: {
    /**
     * Whether or not to show the reels tab option
     *
     * @returns {Boolean}
     */
    shouldShowReelsTab() {
      // Only show this tab for instagram profiles
      return this.platform === "instagram"
    }
  }
}
</script>
